module.exports = __webpack_public_path__ + "static/media/ic-isometric-pull.5c2383e1.svg";